var map = {
	"./building_bg.png": "3c07",
	"./digital_bg.png": "d811",
	"./energy_bg.png": "ff1e",
	"./fmcs_bg.png": "81b0",
	"./home_product_bg.png": "4638",
	"./jidian_bg.png": "9f2a",
	"./robot_bg.png": "ab36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac0a";